import { M as MenuButton } from './vidstack-DLpJQ4a5.js';

class MenuItem extends MenuButton {
}

export { MenuItem as M };
